export const MAIN_BRAND_NAME = atob('Y3liZXJpbnQ=');
